import React, { useEffect, useRef, useState } from "react";
import raipurCampus1 from "../assets/img/campus/raipur-campus-1.jpeg";
import raipurCampus2 from "../assets/img/campus/raipur-campus-2.jpeg";
import raipurCampus3 from "../assets/img/campus/raipur-campus-3.jpeg";

import campus1 from "../assets/img/campus/campus-4.webp";
import campus2 from "../assets/img/campus/campus-9.webp";
import campus3 from "../assets/img/campus/campus-5.webp";

const campusData = {
  raipur: {
    number: "02",
    label: "Raipur Campus",
    title: "A contemporary academic environment in the heart of opportunity.",
    description:
      "Technology-enabled learning spaces and student-focused facilities connect classroom knowledge with practical experience.",
    mainImage: raipurCampus1,
    sideImageOne: raipurCampus2,
    sideImageTwo: raipurCampus3,
  },
  gariyaband: {
    number: "01",
    label: "Gariyaband Campus",
    title: "An immersive campus experience surrounded by space and nature.",
    description:
      "A residential learning environment bringing academics, research, recreation and community life together in one connected campus.",
    mainImage: campus1,
    sideImageOne: campus2,
    sideImageTwo: campus3,
  },
};

const padNumber = (value) => String(value).padStart(2, "0");

export default function Campuses() {

  return (
    <section
      id="campuses"
      className="relative overflow-hidden bg-[#F7F2E8] py-20 sm:py-24 lg:py-28"
    >
      {/* Background decoration */}
      <div
        className="pointer-events-none absolute inset-0"
        aria-hidden="true"
      >
        <div className="absolute -left-40 top-20 h-[420px] w-[420px] rounded-full bg-[#D5AD57]/10 blur-[110px]" />

        <div className="absolute -right-40 bottom-0 h-[460px] w-[460px] rounded-full bg-[#8B1E3F]/[0.06] blur-[120px]" />

        <div className="absolute left-[7%] top-0 h-full w-px bg-[#071A2F]/[0.04]" />
        <div className="absolute right-[7%] top-0 h-full w-px bg-[#071A2F]/[0.04]" />
      </div>

      <div className="relative mx-auto max-w-[1380px] px-5 sm:px-8 lg:px-10">
        {/* SECTION HEADING */}
        <div className="grid gap-8 border-b border-[#071A2F]/10 pb-10 lg:grid-cols-[1fr_0.55fr] lg:items-end">
          <div>
            <div className="flex items-center gap-4">
              <span className="h-px w-10 bg-[#8B1E3F]" />

              <span className="text-sm font-bold uppercase tracking-[0.18em] text-[#8B1E3F]">
                Our Campuses
              </span>
            </div>

            <h2
              className="mt-6 max-w-[900px] text-[clamp(42px,5vw,72px)] font-normal leading-[1.03] tracking-[-0.04em] text-[#071A2F]"
              style={{
                fontFamily: '"Libre Caslon Display", Georgia, serif',
              }}
            >
              Two distinctive campuses.
              <span className="italic text-[#8B1E3F]">
                {" "}
                One academic vision.
              </span>
            </h2>
          </div>

          <div className="lg:pb-2">
            <p className="text-base leading-8 text-[#132337]/65 sm:text-lg">
              Experience learning environments designed around academic
              excellence, practical discovery, student life and meaningful
              connections.
            </p>

            <div className="mt-6 flex items-center gap-4">
              <strong
                className="text-4xl font-normal text-[#D5AD57]"
                style={{
                  fontFamily: '"Libre Caslon Display", Georgia, serif',
                }}
              >
                02
              </strong>

              <span className="h-10 w-px bg-[#071A2F]/15" />

              <span className="text-sm font-bold uppercase leading-6 tracking-[0.13em] text-[#071A2F]/50">
                Distinct campus
                <br />
                experiences
              </span>
            </div>
          </div>
        </div>

        {/* RAIPUR CAMPUS */}
        <article className="group">
          <div className="grid gap-8 lg:grid-cols-[0.56fr_1.44fr] lg:items-stretch">
            {/* Left editorial information */}
            <div className="flex flex-col justify-between rounded-[30px] bg-[#071A2F] p-7 text-white sm:p-9 lg:p-10">
              <div>
                <div className="flex items-center justify-between">
                  <span
                    className="text-[60px] font-normal leading-none text-[#D5AD57]"
                    style={{
                      fontFamily:
                        '"Libre Caslon Display", Georgia, serif',
                    }}
                  >
                    {campusData.gariyaband.number}
                  </span>

                  <span className="rounded-full border border-white/15 px-4 py-2 text-sm font-bold uppercase tracking-[0.12em] text-white/60">
                    Residential
                  </span>
                </div>

                <span className="mt-10 block text-sm font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                  Immersive campus life
                </span>

                <h3
                  className="mt-4 text-[clamp(36px,4vw,54px)] font-normal leading-[1.05]"
                  style={{
                    fontFamily:
                      '"Libre Caslon Display", Georgia, serif',
                  }}
                >
                  {campusData.gariyaband.label}
                </h3>

                <p className="mt-6 text-base leading-8 text-white/60">
                  {campusData.gariyaband.description}
                </p>
              </div>

              {/* Campus feature */}
              <div className="mt-12 border-t border-white/15 pt-7">
                <div className="flex items-end gap-4">
                  <strong
                    className="text-6xl font-normal leading-none text-[#D5AD57]"
                    style={{
                      fontFamily:
                        '"Libre Caslon Display", Georgia, serif',
                    }}
                  >
                    26
                  </strong>

                  <span className="pb-1 text-sm font-bold uppercase leading-5 tracking-[0.12em] text-white/55">
                    Acres of
                    <br />
                    learning environment
                  </span>
                </div>
              </div>
            </div>

            {/* Right image architecture */}
            <div className="grid min-h-[680px] gap-4 sm:grid-cols-[1fr_0.43fr]">
              {/* Main */}
              <div className="relative overflow-hidden rounded-[30px]">
                <img
                  src={campusData.gariyaband.mainImage}
                  alt={`${campusData.gariyaband.label} campus`}
                  className="absolute inset-0 h-full w-full object-cover transition duration-1000 group-hover:scale-[1.025]"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F]/90 via-transparent to-transparent" />

                <div className="absolute inset-x-0 bottom-0 p-7 sm:p-9">
                  <span className="text-sm font-bold uppercase tracking-[0.15em] text-[#D5AD57]">
                    A campus designed around community
                  </span>

                  <h4
                    className="mt-4 max-w-[680px] text-[clamp(28px,3vw,44px)] font-normal leading-[1.08] text-white"
                    style={{
                      fontFamily:
                        '"Libre Caslon Display", Georgia, serif',
                    }}
                  >
                    {campusData.gariyaband.title}
                  </h4>
                </div>
              </div>

              {/* Secondary images */}
              <div className="grid gap-4">
                <div className="relative overflow-hidden rounded-[24px]">
                  <img
                    src={campusData.gariyaband.sideImageOne}
                    alt="Campus learning space"
                    className="absolute inset-0 h-full w-full object-cover transition duration-700 hover:scale-105"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F]/80 to-transparent" />

                  <span className="absolute bottom-5 left-5 right-5 text-sm font-bold uppercase tracking-[0.12em] text-white">
                    Knowledge Spaces
                  </span>
                </div>

                <div className="relative overflow-hidden rounded-[24px]">
                  <img
                    src={campusData.gariyaband.sideImageTwo}
                    alt="Practical learning facility"
                    className="absolute inset-0 h-full w-full object-cover transition duration-700 hover:scale-105"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F]/80 to-transparent" />

                  <span className="absolute bottom-5 left-5 right-5 text-sm font-bold uppercase tracking-[0.12em] text-white">
                    Practical Discovery
                  </span>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* EDITORIAL DIVIDER */}
        <div className="my-16 flex items-center gap-6 sm:my-20">
          <span className="h-px flex-1 bg-[#071A2F]/10" />

          <div className="flex items-center gap-3">
            <span className="h-2 w-2 rounded-full bg-[#8B1E3F]" />
            <span className="h-2 w-2 rounded-full bg-[#D5AD57]" />
            <span className="h-2 w-2 rounded-full bg-[#071A2F]" />
          </div>

          <span className="h-px flex-1 bg-[#071A2F]/10" />
        </div>

        {/* GARIYABAND CAMPUS        Different composition from Raipur */}
        <article className="group mt-14">
          {/* Campus identity */}
          <div className="mb-6 flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between">
            <div className="flex items-center gap-5">
              <span
                className="text-[54px] font-normal leading-none text-[#D5AD57]"
                style={{
                  fontFamily: '"Libre Caslon Display", Georgia, serif',
                }}
              >
                {campusData.raipur.number}
              </span>

              <div>
                <span className="text-sm font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                  City-connected learning
                </span>

                <h3
                  className="mt-1 text-3xl font-normal text-[#071A2F] sm:text-4xl"
                  style={{
                    fontFamily: '"Libre Caslon Display", Georgia, serif',
                  }}
                >
                  {campusData.raipur.label}
                </h3>
              </div>
            </div>

            <span className="hidden text-sm font-bold uppercase tracking-[0.14em] text-[#071A2F]/35 sm:block">
              Urban Academic Experience
            </span>
          </div>

          {/* Visual composition */}
          <div className="grid gap-4 lg:grid-cols-[1.48fr_0.52fr]">
            {/* Main image */}
            <div className="relative min-h-[520px] overflow-hidden rounded-[30px] bg-[#071A2F] sm:min-h-[600px] lg:min-h-[660px]">
              <img
                src={campusData.raipur.mainImage}
                alt={`${campusData.raipur.label} campus`}
                className="absolute inset-0 h-full w-full object-cover transition duration-1000 group-hover:scale-[1.025]"
              />

              {/* Image treatment */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F]/95 via-[#071A2F]/15 to-transparent" />

              <div className="absolute inset-x-0 bottom-0 p-6 sm:p-9 lg:p-11">
                <span className="inline-flex items-center gap-3 text-sm font-bold uppercase tracking-[0.15em] text-[#D5AD57]">
                  <span className="h-px w-8 bg-current" />
                  Raipur
                </span>

                <h4
                  className="mt-5 max-w-[750px] text-[clamp(30px,3.4vw,50px)] font-normal leading-[1.08] text-white"
                  style={{
                    fontFamily:
                      '"Libre Caslon Display", Georgia, serif',
                  }}
                >
                  {campusData.raipur.title}
                </h4>

                <p className="mt-5 max-w-[680px] text-base leading-8 text-white/70">
                  {campusData.raipur.description}
                </p>
              </div>

              {/* Campus number */}
              <div className="absolute right-6 top-6 flex h-[76px] w-[76px] items-center justify-center rounded-full border border-white/30 bg-[#071A2F]/30 backdrop-blur-md sm:right-8 sm:top-8">
                <span
                  className="text-2xl text-white"
                  style={{
                    fontFamily:
                      '"Libre Caslon Display", Georgia, serif',
                  }}
                >
                  01
                </span>
              </div>
            </div>

            {/* Side images */}
            <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-1">
              <div className="group/image relative min-h-[280px] overflow-hidden rounded-[24px] lg:min-h-0">
                <img
                  src={campusData.raipur.sideImageOne}
                  alt="University knowledge and learning space"
                  className="absolute inset-0 h-full w-full object-cover transition duration-700 group-hover/image:scale-105"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F]/80 via-transparent to-transparent" />

                <div className="absolute inset-x-0 bottom-0 p-6">
                  <span className="text-sm font-bold uppercase tracking-[0.14em] text-[#D5AD57]">
                    Knowledge Spaces
                  </span>

                  <p className="mt-2 text-base font-semibold text-white">
                    Environments designed for focused learning.
                  </p>
                </div>
              </div>

              <div className="group/image relative min-h-[280px] overflow-hidden rounded-[24px] lg:min-h-0">
                <img
                  src={campusData.raipur.sideImageTwo}
                  alt="University practical learning facility"
                  className="absolute inset-0 h-full w-full object-cover transition duration-700 group-hover/image:scale-105"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F]/80 via-transparent to-transparent" />

                <div className="absolute inset-x-0 bottom-0 p-6">
                  <span className="text-sm font-bold uppercase tracking-[0.14em] text-[#D5AD57]">
                    Practical Discovery
                  </span>

                  <p className="mt-2 text-base font-semibold text-white">
                    Learning that extends beyond the classroom.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* BOTTOM CTA */}
        <div className="mt-14 flex flex-col gap-6 border-t border-[#071A2F]/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <span className="text-sm font-bold uppercase tracking-[0.15em] text-[#8B1E3F]">
              Experience ISBM University
            </span>

            <p
              className="mt-2 max-w-2xl text-2xl font-normal leading-snug text-[#071A2F] sm:text-3xl"
              style={{
                fontFamily: '"Libre Caslon Display", Georgia, serif',
              }}
            >
              Discover the campus where your university journey can take
              shape.
            </p>
          </div>

          <a
            href="/contact-us"
            className="group inline-flex min-h-[54px] shrink-0 items-center justify-center gap-4 rounded-full bg-[#8B1E3F] px-7 text-sm font-bold text-white shadow-[0_14px_35px_rgba(139,30,63,0.18)] transition duration-300 hover:-translate-y-1 hover:bg-[#071A2F]"
          >
            Plan a Campus Visit

            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white/10 transition duration-300 group-hover:rotate-45">
              ↗
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}